import { IProductImages2 } from 'types'

export default function calculatePriceWithVariantedList(value: number, item: IProductImages2): number {
  let price: number = 0

  if (value === 0) {
    price = item?.originalPrice || item?.price || item?.price_1_price || 0
  } else if (item?.price_3_isActive && value >= Number(item?.price_3_startAmount)) {
    price = item?.price_3_price || 0
  } else if (item?.price_2_isActive && value >= Number(item?.price_2_startAmount) && value <= Number(item?.price_2_endAmount)) {
    price = item?.price_2_price || 0
  } else if (item?.isPriceWithVariants && value >= 1 && value <= Number(item?.price_1_endAmount)) {
    price = item?.price_1_price || item?.price || 0
  } else {
    price = item?.originalPrice || item?.price || 0
  }

  return price
}